var render = function render(_c,_vm){return _c('a',{staticClass:"grid-view__row-more",on:{"click":function($event){_vm.listeners['edit-modal'] && _vm.listeners['edit-modal']()}}},[_c('i',{staticClass:"iconoir-expand"})])
}
var staticRenderFns = []

export { render, staticRenderFns }